import { Injectable } from '@angular/core';

import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { AngularFireAuth } from '@angular/fire/compat/auth';

interface SendEmailCodeRequest {
  email: string;
}

interface VerifyEmailCodeRequest {
  email: string;
  code: string;
}

interface VerifyEmailCodeResponse {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailCodeService {

  constructor(private fns: AngularFireFunctions,
              private auth: AngularFireAuth) {
  }

  sendEmailCode(email: string): Promise<void> {
    return this.fns.httpsCallable<SendEmailCodeRequest>('login-sendEmailCode')({email}).toPromise();
  }

  verifyEmailCode(email: string, code: string): Promise<void> {
    return this.fns.httpsCallable<VerifyEmailCodeRequest, VerifyEmailCodeResponse>('login-verifyEmailCode')({email, code})
      .toPromise()
      .then(response => {
        return this.auth.signInWithCustomToken(response.token);
      })
      .then(userCredential => {
        console.log(`Signed in as user ${userCredential.user.uid}`);
        return;
      });
  }
}
